module.exports = __webpack_public_path__ + "img/taobaozhibo.ead86aeb.png";